var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplianceXlsxFile(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 210,
    viewBox: "0 0 201 210",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-3.4%",
    y: "-3.2%",
    width: "107.2%",
    height: "106.5%",
    filterUnits: "objectBoundingBox",
    id: "c7k9a2lnqa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#c7k9a2lnqa)",
    fill: "#F0EFEF",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0h135.207l51.101 51.101V196a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 38.708,
    height: 38.626,
    rx: 4,
    transform: "translate(80.847 80.07)",
    fill: "#107C41",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.239 110.527 7.074-11.145-6.48-11.082h5.215l3.536 7.084c.325.671.548 1.172.67 1.503h.046c.235-.537.478-1.059.732-1.565l3.78-7.022h4.786l-6.645 11.02 6.814 11.207h-5.092l-4.085-7.782a6.523 6.523 0 0 1-.488-1.038h-.06c-.071.248-.23.585-.473 1.008l-4.208 7.812H90.24z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.207 5 51.101 51.101h-47.101a4 4 0 0 1-4-4V5z",
    fill: "#6AAA86"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceXlsxFile);
export default __webpack_public_path__ + "static/media/compliance-xlsx-file.5c7ccc84.svg";
export { ForwardRef as ReactComponent };